import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AccountSearchModel } from '../../Models/Models/Transformation/Account/AccountSearchModel';
import { AccountType } from '../../Constants/Enums/Domain/AccountType';
import { AccountStatus } from '../../Models/Domains/Account/SlAccounts/AccountStatus';
import { AdvancedSearchFilterType } from '../../Constants/Enums/Search/AdvancedSearchFilterType';
import { SubAccountType } from '../../Constants/Enums/Domain/SubAccountType';

declare var IS_RUNNING_IN_APP_POOL;

export class AccountSearchQueryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(accountName: string, accountNum: string, advCode: string, accountType: AccountType, statuses: Array<AccountStatus>, companyName: string, networkName: string, currentPage: number, count: number, filterType: AdvancedSearchFilterType, wrappers: Array<SubAccountType>, investedInMandates: boolean, mandateNames: Array<string>, hasRegularPayments: boolean, hasRegularWithdrawals: boolean, ServicePropositionsToExclude: Array<number>): Promise<AccountSearchModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/AccountSearchQuery/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { accountName: accountName, accountNum: accountNum, advCode: advCode, accountType: accountType, statuses: statuses, companyName: companyName, networkName: networkName, currentPage: currentPage, count: count, filterType: filterType, wrappers: wrappers, investedInMandates: investedInMandates, mandateNames: mandateNames, hasRegularPayments: hasRegularPayments, hasRegularWithdrawals: hasRegularWithdrawals, ServicePropositionsToExclude: ServicePropositionsToExclude }

    return AjaxWrapper.get<AccountSearchModel, any>(url, data);
  }
}

